import React from 'react';
import { connect } from 'react-redux';
import  {IndexLink,Link,withRouter} from 'react-router';
import axios from 'axios';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

var querystring = require('querystring');

class RecruitePage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
		
        this.state = {
            email: '',
            pass: '',
			companyInfo: {}
        }		
    }
	

    componentWillMount() {
        this.getCompanyInfor();
    }

    getCompanyInfor() {
        var url = '/code/apis.php?api=getEditCompany';
        var data = new FormData();
        axios.post(url, data)
            .then(response => {
                if (response.data.status == 1) {
                    var companyInfo = response.data.data.companyInfo;
					
					if (companyInfo.is_recruite == true ) {
						window.location = "/recruite";
					}
                }
                return response;
            }).catch(error => {});
    }

    handleChange(propertyName, event) {
        const user = this.state;
        user[propertyName] = event.target.value;
        this.setState(Object.assign({}, user));
    }

    handleOnKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.submitForm();
        }
    }

    handleSignIn = (event) => {
        this.submitForm();
    }

    submitForm() {
        var params = Object.assign({}, this.state);

        axios.post('/code/apis.php?api=login_recruite', querystring.stringify(params))
            .then(response => {
                if (response.data.status == 1) {
                    window.location = "/recruite";
                }
                else {
                    this.props.openDialog(response.data.message);
                    return;
                }
                return response;
            });
    }

    render() {
        if (isMobile) {
            return (
                <div id={"response-home-mobile"}>
                <div className={"block-001"}>
                    <Link to="/business">
                        <img className={"img_logo"} src="/static/img/appimg/h_logo.png"/>
                    </Link>
                </div>
                <div className="account_box_wrappers">
                    <div className={"head"}>
                        <div className={"content"}>
                            <h3>Sign in to Recruiter</h3>
                            <small className={"recruite_from"}>You can use the same email address and password that you use on Versity</small>

                            <input
                                name="fname"
                                value={this.state.email}
                                onChange={this.handleChange.bind(this, 'email')}
                                type="text"
                                placeholder={"Email address"}
                                className={"form-control input-lg"}
                                required
                            />
                        </div>
                    </div>
                    <div className={"bottom"}>
                        <div className={"content"}>
                            <input
                                name="fname"
                                value={this.state.pass}
                                onChange={this.handleChange.bind(this, 'pass')}
                                onKeyPress={this.handleOnKeyPress.bind(this)}
                                type="password"
                                placeholder={"Password"}
                                className={"form-control input-lg"}
                                required
                            />

                            <p>&nbsp;</p>
                            <input
                                type="button"
                                className={"btn btn-lg btn-primary btn-block"}
                                name="flogin"
                                onClick={this.handleSignIn.bind(this)}
                                value="Sign In"/>
                        </div>
                    </div>
                </div>
                </div>
            )
        }

        return (
            <div className="advertise_boxs" id={"t_welcome"}>
                <div className={"block-001"}>
                    <Link to="/business">
                        <img className={"img_logo"} src="/static/img/appimg/h_logo.png"/>
                    </Link>
                </div>
                <div className={"row recruite_from"}>
                    <div className="account_box account_signin">
                        <div id="content">
                            <div className="container recruite-login">
                                <div className={"title"}>
                                    Sign in to Recruiter
                                </div>
                                <div className={"sub-title"}>
                                    You can use the same email address and password that you use on Versity
                                </div>
                                <div className={"form-item"}>
                                    <div className="form-group row">
                                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Email address</label>
                                        <div className="col-sm-8">
                                            <input
                                                name="fname"
                                                value={this.state.email}
                                                onChange={this.handleChange.bind(this, 'email')}
                                                type="text"
                                                className="form-control"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Password</label>
                                        <div className="col-sm-8">
                                            <input
                                                name="fname"
                                                value={this.state.pass}
                                                onChange={this.handleChange.bind(this, 'pass')}
                                                onKeyPress={this.handleOnKeyPress.bind(this)}
                                                type="password"
                                                className="form-control"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-10 text-center">
                                            <button type="button" onClick={this.handleSignIn.bind(this)} className="btn btn-info text-info">Sign In</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

RecruitePage.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default withRouter(RecruitePage);


/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/recruite.js
 **/